<template>
  <section v-on:click="openMenu = false; shareOpen = false;"
    :class="{cropping: cropping}">
    <button class="backBtn" v-on:click="goBack"><span>Kembali</span></button>
    <div class="sound withBack">
      <div :class="{soundBtn: true, on: audioPlaying}" v-on:click="$emit('play')"></div>
      <div class="soundLabel">
        Sound
        <span v-if="audioPlaying">On</span>
        <span v-else>Off</span>
      </div>
    </div>
    <div class="menuCnt">
      <div class="menuToggle" v-on:click.stop="openMenu = !openMenu"></div>
      <div :class="{menu: true, open: openMenu}" v-on:click.stop="doNothing">
        <div class="menuItem left" v-on:click="openDownload">Download Brosur</div>
        <div class="menuItem right" v-on:click="openFaq">FAQ</div>
      </div>
    </div>
    <div class="lHeader">
      <div class="leafL"></div><div class="leafR"></div>
      <div class="rumputL"></div><div class="rumputL rumputL2"></div>
      <div class="rumputR"></div><div class="rumputR rumputR2"></div>
    </div>
    <div :class="{title: true, an: titleAn}" v-if="!cropping"></div>
    <div class="umang"></div><div class="star1"></div><div class="star2"></div>
    <div class="imgEditor" v-if="cropping">
      <div class="editorL">
        <div class="cropCnt"
          :class="{fr1: selectedFrame === 0, fr2: selectedFrame === 1,
            fr3: selectedFrame === 2, fr4: selectedFrame === 3,
            fr5: selectedFrame === 4, saving: saving, potrait: cropRatio === 'potrait'}">
          <Cropper :src="image.src" v-on:change="imgChanged"
            ref="cropper" :autoZoom="true"
            :stencil-props="cropOptions"></Cropper>
          <div class="cropAction">
            <div class="caItem zo" v-on:click="$refs.cropper.zoom(0.5)"></div>
            <div class="caItem zi" v-on:click="$refs.cropper.zoom(2)"></div>
            <div class="caItem fh" v-on:click="$refs.cropper.flip(true, false)"></div>
            <div class="caItem fv" v-on:click="$refs.cropper.flip(false, true)"></div>
            <div class="caItem rl" v-on:click="$refs.cropper.rotate(-90)"></div>
            <div class="caItem rr" v-on:click="$refs.cropper.rotate(90)"></div>
          </div>
          <div class="btnCnt">
            <button class="btn rounded orange almost"
              v-on:click="openFrameSelector = true">Pilih Frame</button>
            <button class="btn rounded orange"
              :class="{btnLoading: saving}"
              v-on:click="saveNow">Simpan Foto</button>
          </div>
        </div>
      </div>
      <div class="editorCnt" :class="{open: openFrameSelector}">
        <div class="editorIn">
          <div class="editorOpt">
            <h4>Pilih Ukuran Foto</h4>
            <div :class="{optEd: true, potrait: true, active: cropRatio === 'potrait'}"
              v-on:click="setCropRatio('potrait')">
              <div class="radio"></div>
              <h4>9x6 Potrait</h4>
              <p>Bagus untuk Instagram Story</p>
            </div>
            <div :class="{optEd: true, square: true, active: cropRatio === 'square'}"
              v-on:click="setCropRatio('square')">
              <div class="radio"></div>
              <h4>1x1 Square</h4>
              <p>Bagus untuk Instagram Feed</p>
            </div>
          </div>
          <div class="editorOpt">
            <h4>Pilih Frame</h4>
            <div class="frameCnt" v-if="cropRatio === 'potrait'">
              <div class="frameItem fr1"
                v-on:click="selectedFrame = 0"
                :class="{active: selectedFrame === 0}">
                <div class="frm"></div></div>
              <div class="frameItem fr2"
                v-on:click="selectedFrame = 1"
                :class="{active: selectedFrame === 1}">
                <div class="frm"></div></div>
              <div class="frameItem fr3"
                v-on:click="selectedFrame = 2"
                :class="{active: selectedFrame === 2}">
                <div class="frm"></div></div>
              <div class="frameItem fr4"
                v-on:click="selectedFrame = 3"
                :class="{active: selectedFrame === 3}">
                <div class="frm"></div></div>
              <div class="frameItem fr5"
                v-on:click="selectedFrame = 4"
                :class="{active: selectedFrame === 4}">
                <div class="frm"></div></div>
            </div>
            <div class="frameCnt square" v-else>
              <div class="frameItem fr1"
                v-on:click="selectedFrame = 0"
                :class="{active: selectedFrame === 0}">
                <div class="frm"></div></div>
              <div class="frameItem fr2"
                v-on:click="selectedFrame = 1"
                :class="{active: selectedFrame === 1}">
                <div class="frm"></div></div>
              <div class="frameItem fr3"
                v-on:click="selectedFrame = 2"
                :class="{active: selectedFrame === 2}">
                <div class="frm"></div></div>
              <div class="frameItem fr4"
                v-on:click="selectedFrame = 3"
                :class="{active: selectedFrame === 3}">
                <div class="frm"></div></div>
              <div class="frameItem fr5"
                v-on:click="selectedFrame = 4"
                :class="{active: selectedFrame === 4}">
                <div class="frm"></div></div>
            </div>
          </div>
          <button class="btn orange rounded lg savePhoto" :class="{btnLoading: saving}"
            v-on:click="saveNow">Simpan Foto</button>
          <button class="btn orange rounded apply almost"
            v-on:click="openFrameSelector = false">Terapkan Pilihan</button>
        </div>
      </div>
    </div>
    <div class="stages" v-else-if="imgResult">
      <div :class="{imgResult: true, square: cropRatio === 'square'}">
        <div class="theResult">
          <img :src="imgResult">
        </div>
        <p>Jangan lupa post fotomu di Instagram dengan mention IG @nutrilite_id
          dan hashtag #youthfuelsummerfest pada 2 Oktober 2021,
          jam 10.00 – 15.00 WIB ya!</p>
        <button class="btn orange rounded almost"
          v-on:click="$refs.shareDialog.open()">Bagikan</button>
        <a :href="imgResult" download target="_blank"
          class="btn orange rounded almost">Download<span> Photo</span></a>
      </div>
      <div class="tide"></div><div class="tideBg"></div>
    </div>
    <div class="stages" v-else>
      <div class="stageItem">
        <div class="jemuran"></div>
        <div class="howto">
          <h4>Dapatkan 10 hadiah Collagen Drink dan Nutrilite Shaker
            di area photo booth dan games. Gimana caranya?</h4>
          <ol>
            <li>Post photo/games kamu di Instagram Story dengan mention
              IG @nutrilite_id</li>
            <li>Mention 5 teman kamu untuk ikut acara ini</li>
            <li>Gunakan hashtag #youthfuelsummerfest</li>
            <li>Hanya berlaku di 2 Oktober 2021, jam 10.00 – 15.00 WIB</li>
            <li>Nantikan pengumuman pemenang di akhir acara di Main Stage</li>
          </ol>
        </div>
        <button v-on:click="$refs.file.click()"
          class="btn orange rounded lg">Upload Gambar</button>
        <!--
        <router-link to="/fun-and-learn/show-your-smile/camera"
          class="btn orange rounded">Ambil Foto</router-link>
        -->
      </div>
      <div class="tide"></div><div class="tideBg"></div>
    </div>
    <input type="file" ref="file" style="display: none;"
      accept="image/*" v-on:change="handleFile">
    <div class="bolaPantai"></div><div class="payungB"></div><div class="payungA"></div>
    <div class="tide"></div><div class="tideBg"></div>
    <div class="copyright">
      <div class="shareFooter" :class="{open: shareOpen}"
        v-on:click.stop="shareOpen = !shareOpen"></div>
      <div class="socialLink" :class="{open: shareOpen}"
        v-on:click.stop="doNothing">
        <div class="sclLabel">Find Us On:</div>
        <a class="sclItem ig" target="_blank"
          href="https://www.instagram.com/nutrilite_id/"></a>
        <a class="sclItem fb" target="_blank"
          href="https://www.facebook.com/NutriliteID"></a>
        <a class="sclItem tw" target="_blank" :href="twUri"></a>
        <a class="sclItem wa" target="_blank" :href="waText"></a>
      </div>
      <div class="copy">
        &copy; Nutrilite Indonesia {{y}}
      </div>
    </div>
    <Main ref="main"/>
    <Faq ref="faq"/>
    <Download ref="download"/>
    <ShareDialog ref="shareDialog"/>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import 'vue-advanced-cropper/dist/theme.compact.css';
import Main from '@/components/Main.vue';
import Faq from '@/components/Faq.vue';
import Download from '@/components/Download.vue';
import ShareDialog from '@/components/ShareDialog.vue';

export default {
  name: 'home',
  components: {
    Main,
    Faq,
    Cropper,
    Download,
    ShareDialog,
  },
  data() {
    return {
      y: '',
      name: '',
      titleAn: false,
      openMenu: false,
      file: null,
      image: { src: null, type: null },
      cropOptions: {
        aspectRatio: 9 / 16,
      },
      imgResult: null,
      cropping: false,
      shareOpen: false,
      cropRatio: 'potrait',
      selectedFrame: 0,
      saving: false,
      openFrameSelector: false,
    };
  },
  methods: {
    doNothing() {},
    openDownload() {
      this.openMenu = false;
      this.$refs.download.open();
    },
    openFaq() {
      this.openMenu = false;
      this.$refs.faq.open();
    },
    reset() {
      this.image = { src: null, type: null };
    },
    setCropRatio(rt) {
      this.cropRatio = rt;
      if (rt === 'potrait') this.cropOptions = { aspectRatio: 9 / 16 };
      else this.cropOptions = { aspectRatio: 1 };
      const imgTmp = { src: this.image.src, type: this.image.type };
      this.reset();
      setTimeout(() => {
        this.image = imgTmp;
      });
    },
    handleFile(e) {
      if (!this.$refs.file.files || this.$refs.file.files.length < 1) return;
      [this.file] = this.$refs.file.files;
      if (!this.file) return;
      if (this.image.src) URL.revokeObjectURL(this.image.src);
      const blob = URL.createObjectURL(this.file);
      this.image = {
        src: blob,
        type: this.file.type,
      };
      this.cropping = true;
    },
    imgChanged({ coordinates, image }) {
      this.result = { coordinates, image };
    },
    goBack() {
      if (this.openFrameSelector) {
        this.openFrameSelector = false;
      } else if (this.cropping) {
        this.cropping = false;
      } else {
        this.$router.push('/fun-and-learn');
      }
    },
    saveNow() {
      this.saving = true;
      const { canvas } = this.$refs.cropper.getResult();
      if (!canvas) return;
      const formData = new FormData();
      canvas.toBlob((blob) => {
        formData.append('file', blob);
        this.$http.post(this.$config.uri('user/frame'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
          },
        }).then((r) => {
          if (!r.data || r.data.status !== 200) {
            // Failed bro
            return;
          }
          // Now generate frame
          this.$http.post(this.$config.uri(`user/frame/${r.data.id}/gen`), {
            type: this.cropRatio,
            frameId: this.selectedFrame,
          }).then((r2) => {
            // Now display frame
            this.saving = false;
            this.imgResult = r2.data.image;
            this.cropping = false;
          });
        });
      });
    },
  },
  computed: {
    ...mapState(['audioPlaying']),
    shareText() {
      return 'Yuk ikutan #YouthfuelSummerFest bersama @nutrilite_id';
    },
    twUri() {
      return 'https://twitter.com/intent/tweet?url='
        + `${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        + `&text=${escape(this.shareText)}&related=Amway,Nutrilite,Collagen`;
    },
    waText() {
      return 'https://api.whatsapp.com/send/?phone&text='
        + `${escape(`${this.shareText} di https://nutrilite.co.id/youthfuelsummerfest/`)}`
        + '&app_absent=0';
    },
  },
  destroyed() {
    if (this.image.src) URL.revokeObjectURL(this.image.src);
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Show Your Smile - '
      + 'Youthfuel Summer Fest – Amunisi Segar Untuk Kulitmu';
    const d = new Date();
    this.y = d.getFullYear();
    this.name = localStorage.getItem('name');
    const token = localStorage.getItem('token');
    if (!token) {
      this.$refs.main.open((name) => {
        this.name = name;
      });
    }
    setTimeout(() => {
      this.titleAn = true;
    });
    window.addEventListener('message', (e) => {
      this.openCatch = false;
    });
  },
};
</script>

<style lang="scss">
  .cropCnt{
    // &.saving{
    //   .cropAction{
    //     display: none !important;
    //   }
    //   &:before{
    //     background-color: rgba(206, 145, 146, .78);
    //     content: "";
    //     position: absolute;
    //     left: 0; top: 0; right: 0; bottom: 0;
    //     z-index: 9;
    //   }
    // }
    .vue-preview__wrapper{
      &:before{
        position: absolute;
        content: "";
        top: 0; left: 0; right: 0; bottom: 0;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        z-index: 1;
      }
    }
    &.fr1{
      .vue-preview__wrapper:before{
        background-image: url(../assets/frame/21.png);
      }
    }
    &.fr2{
      .vue-preview__wrapper:before{
        background-image: url(../assets/frame/22.png);
      }
    }
    &.fr3{
      .vue-preview__wrapper:before{
        background-image: url(../assets/frame/23.png);
      }
    }
    &.fr4{
      .vue-preview__wrapper:before{
        background-image: url(../assets/frame/24.png);
      }
    }
    &.fr5{
      .vue-preview__wrapper:before{
        background-image: url(../assets/frame/25.png);
      }
    }
    &.potrait{
      &.fr1{
        .vue-preview__wrapper:before{
          background-image: url(../assets/frame/11.png);
        }
      }
      &.fr2{
        .vue-preview__wrapper:before{
          background-image: url(../assets/frame/12.png);
        }
      }
      &.fr3{
        .vue-preview__wrapper:before{
          background-image: url(../assets/frame/13.png);
        }
      }
      &.fr4{
        .vue-preview__wrapper:before{
          background-image: url(../assets/frame/14.png);
        }
      }
      &.fr5{
        .vue-preview__wrapper:before{
          background-image: url(../assets/frame/15.png);
        }
      }
    }
  }
</style>
<style scoped lang="scss">
.imgEditor{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  display: flex;
  z-index: 991;
  @media (max-width: 1000px) {
    display: block;
  }
  @media (max-height: 720px) {
    position: relative;
    height: 100vh;
  }
  .editorL{
    width: calc(100% - 380px);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 1000px) {
      width: 100%;
      padding: 0;
      position: fixed;
      top: 0; bottom: 0;
      background-color: #000;
      background-image: url(../assets/game-bg.jpg);
    }
    @media (max-height: 720px) and (min-width: 1001px) {
      display: block;
      overflow: auto;
      padding: 100px 0;
    }
    .cropCnt{
      width: 800px; height: 520px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      background-color: #000;
      position: relative;
      border-radius: 10px;
      box-shadow: 2px 2px 6px rgba(0,0,0,.4);
      .btnCnt{
        display: none;
      }
      @media (max-width: 1200px) {
        width: 600px;
        height: 440px;
        border-radius: 0;
      }
      @media (max-width: 1000px) {
        width: 100%;
        height: 100%;
        .btnCnt{
          display: block;
          position: fixed;
          bottom: 16px; left: 0; right: 0;
          text-align: center;
          .btn{
            margin: 0 6px;
          }
        }
      }
    }
    .cropAction{
      position: absolute;
      left: 50%; bottom: -44px;
      transform: translateX(-50%);
      display: flex;
      @media (max-width: 1000px) {
        bottom: 70px;
      }
      .caItem{
        width: 34px; height: 34px;
        border-radius: 3px;
        background-color: rgba(0,0,0,.2);
        margin: 0 5px;
        cursor: pointer;
        transition: all .3s ease;
        color: #fff;
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
        &.zo{
          background-image: url(../assets/cropper/zoom-out.svg);
        }
        &.zi{
          background-image: url(../assets/cropper/zoom-in.svg);
        }
        &.fh{
          background-image: url(../assets/cropper/flip-horizontal.svg);
        }
        &.fv{
          background-image: url(../assets/cropper/flip-vertical.svg);
        }
        &.rl{
          background-image: url(../assets/cropper/rotate-counter-clockwise.svg);
        }
        &.rr{
          background-image: url(../assets/cropper/rotate-clockwise.svg);
        }
        &:hover{
          background-color: rgba(0,0,0,.4);
        }
      }
    }
  }
  .editorCnt{
    width: 380px; height: 100%;
    box-sizing: border-box;
    background-color: #ffe6e9;
    display: flex;
    align-items: center;
    .apply{ display: none; }
    @media (max-width: 1000px) {
      width: auto;
      position: fixed;
      left: 0; right: 0; top: 0;
      display: block;
      padding-top: 64px;
      top: 100%;
      transition: all .3s ease;
      &.open{
        top: 0;
      }
      .savePhoto{
        display: none;
      }
      .apply{
        display: block;
      }
    }
    @media (max-height: 720px) and (min-width: 1001px) {
      display: block;
      padding: 100px 0 40px;
      overflow: auto;
      height: 100%;
    }
    .editorIn{
      width: 100%;
      .editorOpt{
        margin-bottom: 20px;
        h4{
          margin: 0 20px 10px;
          font-size: 18px;
        }
        .optEd{
          position: relative;
          padding: 10px 40px;
          padding-left: 120px;
          transition: all .3s ease;
          cursor: pointer;
          .radio{
            width: 22px; height: 22px;
            position: absolute;
            border-radius: 50%;
            left: 40px; top: 14px;
            border: #fff 3px solid;
            box-sizing: border-box;
            &:before{
              content: "";
              position: absolute;
              left: 2px; right: 2px; top: 2px; bottom: 2px;
              border-radius: 50%;
            }
          }
          &:hover{
            background-color: #fddbdf;
            .radio{
              border-color: #de8da0;
            }
          }
          &.active{
            .radio{
              border-color: #de8da0;
              &:before{
                background-color: #de8da0;
              }
            }
          }
          &.potrait{
            &:before{
              width: 24px; height: 38px;
              background-color: #de8da0;
              position: absolute;
              left: 80px; top: 15px;
              content: "";
            }
          }
          &.square{
            &:before{
              width: 24px; height: 24px;
              background-color: #de8da0;
              position: absolute;
              left: 80px; top: 15px;
              content: "";
            }
          }
          h4{
            font-size: 24px;
            margin: 0;
            @media (max-width: 1000px) {
              font-size: 20px;
            }
          }
          p{
            margin: 0;
            font-weight: normal;
            @media (max-width: 1000px) {
              font-size: 15px;
            }
          }
        }
        .zoomCnt{
          padding: 10px 40px 0;
        }
      }
      .frameCnt{
        display: flex;
        flex-wrap: wrap;
        margin: 0 40px;
        .frameItem{
          width: 33.33333%;
          height: 120px;
          margin: 0 0 10px;
          position: relative;
          .frm{
            position: absolute;
            top: 0; bottom: 0; left: 5px; right: 5px;
            background-position: center;
            background-size: auto 90%;
            background-repeat: no-repeat;
            background-color: #fff;
            transition: all .3s ease;
            cursor: pointer;
            &:hover{
              background-color: #f5f3ea;
            }
          }
          &.fr1{
            .frm{
              background-image: url(../assets/frame/11.png);
            }
          }
          &.fr2{
            .frm{
              background-image: url(../assets/frame/12.png);
            }
          }
          &.fr3{
            .frm{
              background-image: url(../assets/frame/13.png);
            }
          }
          &.fr4{
            .frm{
              background-image: url(../assets/frame/14.png);
            }
          }
          &.fr5{
            .frm{
              background-image: url(../assets/frame/15.png);
            }
          }
          &.active{
            .frm{
              background-color: #fcdf51;
            }
          }
        }
        &.square{
          .frameItem{
            height: 90px;
            &.fr1{
              .frm{
                background-image: url(../assets/frame/21.png);
              }
            }
            &.fr2{
              .frm{
                background-image: url(../assets/frame/22.png);
              }
            }
            &.fr3{
              .frm{
                background-image: url(../assets/frame/23.png);
              }
            }
            &.fr4{
              .frm{
                background-image: url(../assets/frame/24.png);
              }
            }
            &.fr5{
              .frm{
                background-image: url(../assets/frame/25.png);
              }
            }
          }
        }
      }
      .btn{
        margin-left: 40px;
      }
    }
  }
}
section{
  background-color: #ffc9ca;
  background-image: linear-gradient(#ffc9ca, #fdbbce);
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  @media (max-height: 720px) {
    position: static;
  }
  @media (max-width: 680px) {
    position: static;
  }
}
.btn.almost{
  background-color: #fff5cb;
}

.menuCnt{
  position: fixed;
  right: 0; top: 0;
  overflow: hidden;
  height: 100px; width: 400px;
  z-index: 997;
}
.title{
  width: 440px; height: 260px;
  position: absolute;
  left: 50%; top: -260px;
  background-image: url(../assets/smile-title.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: -220px;
  z-index: 91;
  transition: all .3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &.an{
    top: -80px;
    @media (max-width: 680px) {
      top: -70px;
    }
  }
  @media (max-width: 680px) {
    width: 280px; margin-left: -140px;
  }
}
.catch{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  z-index: 9;
  iframe{
    border: none;
    position: absolute;
    left: 0; top: 0;
    width: 100%; height: 100%;
  }
}
.stages{
  position: absolute;
  top: 50%; left: 0; right: 0;
  z-index: 9;
  transform: translateY(-50%);
  flex-wrap: wrap;
  text-align: center;
  box-sizing: border-box;
  @media (max-width: 680px) {
    min-height: 100vh;
    position: relative;
    transform: none;
    left: auto; top: auto; right: auto;
    display: block;
    transform: none;
    padding-top: 140px;
    margin: 0;
  }
  @media (max-height: 720px) {
    position: relative;
    transform: none;
    left: auto; top: auto; right: auto;
    display: block;
    transform: none;
  }
  @media (max-height: 720px) and (min-width: 681px) {
    padding: 140px 0 60px;
  }
  .imgResult{
    margin: 0 auto;
    position: relative;
    z-index: 9;
    margin: 0 20px;
    @media (max-width: 680px) and (min-height: 740px) {
      position: absolute;
      top: 50%; transform: translateY(-50%);
      left: 0; right: 0;
    }
    img{
      height: 460px;
      box-shadow: 2px 2px 8px rgba(0,0,0,.4);
      border-radius: 10px;
      margin-bottom: 20px;
      @media (max-width: 680px) {
        height: 380px;
      }
    }
    &.square{
      img{
        height: 380px;
        @media (max-width: 680px) {
          height: 300px;
        }
      }
    }
    p{
      max-width: 460px;
      margin: 0 auto 20px;
    }
    .btn{
      margin: 0 10px;
      @media (max-width: 680px) {
        margin: 0 6px;
        span{
          display: none;
        }
      }
    }
  }
  .stageItem{
    position: relative;
    box-sizing: border-box;
    text-align: center;
    .jemuran{
      height: 310px;
      background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/assets/jemuran.png);
      background-size: auto 600px;
      background-position: bottom center;
      @media (max-width: 680px) {
        background-size: auto 400px;
        height: 200px;
      }
    }
    .howto{
      text-align: left;
      background-color: #ffd9e1;
      padding: 20px 40px;
      border-radius: 10px;
      margin: 0 auto 20px;
      max-width: 680px;
      box-sizing: border-box;
      @media (max-width: 720px) {
        max-width: none;
        margin: 0 20px 20px;
      }
      @media (max-width: 680px) {
        padding: 20px;
        padding-top: 30px;
      }
      h4{
        text-align: center;
        margin: 0 0 10px;
        font-family: CarlaSansBold;
        font-size: 16px;
      }
      ol{
        margin: 0;
        padding-left: 20px;
        font-size: 18px;
        @media (max-width: 720px) {
          font-size: 17px;
        }
        li{
          padding-left: 14px;
        }
      }
      p{
        font-size: 18px;
        @media (max-width: 720px) {
          font-size: 17px;
        }
      }
    }
    .btn{
      margin: 0 10px 20px;
      &.almost{
        background-color: #fff5cb;
      }
    }
  }
  .tide, .tideBg{
    display: none;
    position: absolute;
  }
  @media (max-width: 680px) {
    padding-bottom: 140px;
    overflow: hidden;
    position: relative;
    .tide, .tideBg{
      display: block;
    }
  }
}
.payungB{
  width: 300px; height: 300px;
  position: fixed;
  right: -100px; bottom: -100px;
  background-image: url(../assets/umbrela-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
  @media (max-width: 680px) {
    width: 140px; height: 140px;
    right: -60px; bottom: -60px;
  }
}
.payungA{
  width: 300px; height: 300px;
  position: fixed;
  left: -200px; top: 50%;
  margin-top: -150px;
  background-image: url(../assets/umbrela-red.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
  @media (max-width: 680px) {
    width: 140px; height: 140px;
    top: 50%; left: -100px; margin-top: -40px;
  }
}.bolaPantai{
  width: 120px; height: 120px;
  position: fixed;
  right: -60px; top: 50%;
  transform: translateY(-50%);
  margin-top: -30px;
  background-image: url(../assets/bola-pantai.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 4;
  @media (max-width: 680px) {
    width: 80px; height: 80px;
    top: 300px; right: -40px;
  }
}

.tideBg{
  background-image: url(../assets/tide-bg-fliped.png);
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  position: fixed;
  left: -200px; right: 200px; bottom: -180px;
  height: 460px;
  transform: rotate(18deg);
  z-index: 1;
  @media (max-width: 1260px) {
    transform: rotate(20deg);
  }
  @media (max-width: 1024px) {
    right: 0; height: 400px;
  }
  @media (max-width: 680px) {
    height: 200px; bottom: 0;
    display: none;
  }
}
.tide{
  background-image: url(../assets/tide-fliped.png);
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  position: fixed;
  left: -200px; right: 200px; bottom: -260px;
  height: 460px;
  transform: rotate(14deg);
  animation: tideAn 10s infinite ease;
  z-index: 3;
  @media (max-width: 1260px) {
    transform: rotate(18deg);
  }
  @media (max-width: 1024px) {
    right: 0; height: 400px;
  }
  @media (max-width: 680px) {
    height: 200px; bottom: 0;
    animation: tideAnSm 10s infinite ease;
    display: none;
  }
  @keyframes tideAn {
    0% {bottom: -240px;}
    40% {bottom: -300px;}
    60% {bottom: -300px;}
    100% {bottom: -240px;}
  }
  @keyframes tideAnSm {
    0% {bottom: -60px;}
    40% {bottom: -110px;}
    60% {bottom: -110px;}
    100% {bottom: -60px;}
  }
}

.star1{
  width: 74px; height: 74px;
  position: fixed;
  left: 260px; bottom: 180px;
  background-image: url(../assets/star-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 40px; height: 40px;
    left: 20px; bottom: 80px;
  }
}
.star2{
  width: 74px; height: 74px;
  position: fixed;
  right: 36%; bottom: 260px;
  background-image: url(../assets/star-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 60px; height: 60px;
    bottom: 200px; right: 40px;
  }
}
.umang{
  width: 74px; height: 74px;
  position: fixed;
  left: -74px; bottom: 120px;
  background-image: url(../assets/kepiting-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: umangAn 65s infinite linear;
  z-index: 2;
  @media (max-width: 680px) {
    width: 40px; height: 40px;
    bottom: 80px;
  }
  @keyframes umangAn {
    from { left: -74px; }
    to { left: 110%; }
  }
}
.rumputL{
  width: 280px; height: 500px;
  position: fixed;
  left: 380px; top: -396px;
  background-image: url(../assets/rumput-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  @media (max-width: 1100px) and (max-height: 1100px) {
    height: 400px; top: -320px; left: 240px;
  }
  @media (max-width: 680px) {
    height: 240px;
    top: -180px; left: 60px;
    display: none;
  }
  &.rumputL2{
    background-image: url(../assets/rumput-r2.png);
    left: 600px;
    top: -420px;
  }
}
.rumputR{
  width: 280px; height: 500px;
  position: fixed;
  right: 260px; top: -396px;
  background-image: url(../assets/rumput-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  @media (max-width: 680px) {
    display: none;
  }
  &.rumputR2{
    background-image: url(../assets/rumput-l2.png);
    right: 460px;
    top: -420px;
    @media (max-width: 1600px) {
      display: none;
    }
  }
}
.lHeader{
  position: absolute;
  left: 0; right: 0; top: 0;
  overflow: hidden; height: 600px;
}
.leafL{
  width: 540px; height: 540px;
  position: fixed;
  left: -200px; top: -176px;
  background-image: url(../assets/leaf-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: l1An 10s infinite ease;
  z-index: 8;

  // Smaller leaf
  width: 480px; height: 480px;
  left: -160px; top: -160px;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    left: -140px; top: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    left: -80px; top: -80px;
  }
  @keyframes l1An {
    0% {transform: rotate(0deg);}
    10% {transform: rotate(0deg);}
    45% {transform: rotate(10deg);}
    55% {transform: rotate(10deg);}
    90% {transform: rotate(0deg);}
    100% {transform: rotate(0deg);}
  }
}
.leafR{
  width: 540px; height: 540px;
  position: fixed;
  right: -180px; top: -140px;
  background-image: url(../assets/leaf-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;

  width: 480px; height: 480px;
  right: -160px; top: -160px;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    right: -140px; top: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    right: -80px; top: -80px;
  }
}
@keyframes windAn {
  0% {transform: rotate(0deg);}
  10% {transform: rotate(0deg);}
  45% {transform: rotate(8deg);}
  55% {transform: rotate(8deg);}
  90% {transform: rotate(0deg);}
  100% {transform: rotate(0deg);}
}

section.cropping{
  .menuToggle, .copyright, .sound{
    display: none;
  }
}
</style>
